import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import MainForm from '@modules/staff/person/forms/personBasicInfo/componenets/BasicInfoForm';
import PersonFormIcons from '@shared/components/PersonFormIcons';
import EmailForm from '@modules/staff/person/forms/personEmails/components/EmailForm';
import PaymentForm from '@modules/staff/person/forms/personBankAcc/components/PaymentForm';
import FileForm from '@modules/staff/person/forms/personFiles/components/FileForm';
import PhysicianForm from '@modules/staff/person/forms/personPhysician/components/PhysicianForm';
import EducationForm from '@modules/staff/person/forms/personEducation/components/EducationForm';
import LanguageForm from '@modules/staff/person/forms/personLanguages/components/LanguageForm';
import FamilyForm from '@modules/staff/person/forms/personFamilyMemb/components/FamilyMemberForm';
import EmployerForm from '@modules/staff/person/forms/personPrevEmp/components/PrevEmployerForm';
import CollectForm from '@modules/staff/person/forms/personDocuments/components/DocumentsForm';
import RemotelyDocumentsForm from '@modules/staff/person/forms/personRemotely/components/RemotelyDocumentsForm';
import DocumentsForm from '@modules/staff/person/forms/personDocuments/components/DocumentsForm';
import PersonContractForm from '@modules/staff/register/personContract/components/PersonContractForm';
import WorkExperienceForm from '@modules/staff/person/forms/employeeWorkExp/components/WorkExperienceForm';
import CurrentStatus from '@modules/staff/person/forms/employeeStatus/components/CurrentStatus';
import PersonHolidays from '@modules/staff/person/forms/employeeHolidays/components/PersonHolidays';
import EmployerDataEditing from '@modules/staff/person/forms/employeeDataEdit/components/EmployerDataEditing';


export default function PersonForm({
    person,
    onClose,
    fetchData,
    selectedData,
    showRegisterIcons = false,
    initialActiveForm = 'main',
}) {
    const [activeForm, setActiveForm] = useState(initialActiveForm);
    const modalRef = useRef(null);

    useEffect(() => {
        setActiveForm(initialActiveForm || 'main');
    }, [initialActiveForm]);

    const handleModalClick = (e) => {
        if (modalRef.current && e.target === modalRef.current) {
            onClose();
        }
    };


    const renderFormContent = () => {
        switch (activeForm) {
            case 'main':
                return <MainForm person={person} onClose={onClose} fetchData={fetchData} />;
            case 'email':
                return <EmailForm person={person} />;
            case 'payment':
                return <PaymentForm person={person} />;
            case 'files':
                return <FileForm person={person} />;
            case 'medical':
                return <PhysicianForm person={person} />;
            case 'education':
                return <EducationForm person={person} />;
            case 'language':
                return <LanguageForm person={person} />;
            case 'family':
                return <FamilyForm person={person} />;
            case 'building':
                return <EmployerForm person={person} />;
            case 'globe':
                return <CollectForm person={person} />;
            case 'home':
                return <RemotelyDocumentsForm person={person} />;
            case 'documents':
                return (
                    <DocumentsForm
                        person={person}
                        onClose={onClose}
                        fetchData={fetchData}
                        showRegisterContextButtons={showRegisterIcons}
                    />
                );
            case "personContract":
                return (
                    <PersonContractForm
                        person={person}
                        onClose={onClose}
                        activeForm={activeForm}
                        setActiveForm={setActiveForm}
                        initialContractType={person?.personContractType || 'laborContract'}
                        initialSelectedMainContract={person?.selectedMainContract || ''}
                        initialSelectedContractId={person?.selectedContractId || null}
                    />
                );
            case 'workExperience':
                return <WorkExperienceForm person={person} onClose={onClose} />;
            case 'personHolidays':
                return <PersonHolidays person={person} onClose={onClose} />;
            case 'employeeData':
                return <CurrentStatus person={person} onClose={onClose} />;
            case 'empEdit':
                return <EmployerDataEditing person={person} onClose={onClose} />;
            default:
                return null;
        }
    };

    return (
        <div
            className='modal show'
            tabIndex="-1"
            ref={modalRef}
            onClick={handleModalClick}
        >
            <div className="person-form-wrapper" onClick={e => e.stopPropagation()}>
                <div className="modal-content-wrapper">
                    <button className="modal-close-btn" onClick={onClose}>
                        <span>×</span>
                    </button>

                    {person && <PersonFormIcons activeForm={activeForm} setActiveForm={setActiveForm} showRegisterIcons={showRegisterIcons} />}

                    {renderFormContent()}
                </div>
            </div>
        </div>
    );
}